import React, { forwardRef } from 'react'
import { TypographyProps } from './Typography.types'
import { StyledTypography, getVariantElement } from './Typography.styles'

const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ variant = 'body1', component, children, ...props }, ref) => {
    const elementType = getVariantElement(variant, component)

    return (
      <StyledTypography as={elementType} ref={ref} variant={variant} {...props}>
        {children}
      </StyledTypography>
    )
  }
)

Typography.displayName = 'Typography'

export default Typography
